/**
 * BusyNotice - the floating message while a read waits on its busy
 * retry (build-specs/busy-says-so-and-retries-once.md R4, C9): the undo
 * toast's box, in FloatingNotices above the toast. Nothing is shown
 * otherwise, so in normal use nothing on screen changes.
 *
 * The live region stays mounted and only its content comes and goes: a
 * region inserted together with its text is often not announced by
 * screen readers. It is a polite live region rather than role="status",
 * so pages keep a single status message of their own.
 */
import type { ReactNode } from 'react';
import { useBusyRetryPending } from '@/hooks/useBusyRetryPending';
import { FLOATING_BOX_CLS } from '@/components/FloatingNotices';

export function BusyNotice(): ReactNode {
  const pending = useBusyRetryPending();
  return (
    <div aria-live="polite">
      {pending && (
        <div
          data-testid="busy-notice"
          className={`${FLOATING_BOX_CLS} text-sm mb-2`}
        >
          Things are busy right now. This will try again in a moment.
        </div>
      )}
    </div>
  );
}
